import { render } from "./SelectSingle.vue?vue&type=template&id=0b3dc1d3"
import script from "./SelectSingle.vue?vue&type=script&lang=js"
export * from "./SelectSingle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__